import React from "react";

import TitleFragment from "./TitleFragment";
import DevPartnerImg from "./images/customers/developement-partners.webp";
import TrainPartnerImg from "./images/customers/customers-pthinks.webp"
import { useTranslation } from "react-i18next";

import '../App.css';

function MoreCustomers() {
    const { t } = useTranslation();

    return (
        <div className="customers">
            <TitleFragment title={t('more_customers.title')} />

            <div className="app_sub_title">{t('more_customers.dev_partners')}</div>

            <div className="customers_div"><img className="customers_dev_img" src={DevPartnerImg} alt={t('more_customers.dev_alt')} /></div>

            <div className="app_sub_title">{t('more_customers.training_partners')}</div>

            <div className="customers_div"><img className="customers_dev_img" src={TrainPartnerImg} alt={t('more_customers.train_alt')} /></div>
        </div>
    )
}

export default MoreCustomers;